import { Component, HostListener, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { QuestionnaireService } from '../services/questionnaire.service';


@Component({
  selector: 'app-terms-of-use-final',
  templateUrl: './terms-of-use-final.component.html',
  styleUrls: ['./terms-of-use-final.component.scss']
})
export class TermsOfUseFinalComponent implements OnInit {

  agree: FormControl = new FormControl(false);
  errorMessage = "";
  currentStep: any;
  constructor(public activeModal: NgbActiveModal,
    private questionnaireService: QuestionnaireService,
    private translate: TranslateService) { }
  isAdvisor = this.questionnaireService.getIsAdvisor();
  ngOnInit() {
    if (this.questionnaireService.openTermsOfUse === true) {
      this.activeModal.close();
    }
    // this.currentStep = this.questionnaireService.getStep("summarize");
  }
  save() {
    if (this.agree.value) {
      this.activeModal.close({ isAgree: true });
      this.currentStep = this.questionnaireService.getStep("summarize");
      let termOfUseFinal = { text: this.translate.instant('SUMMARIZE.FORM_COMPLITED') + '-' + this.translate.instant('TERMS_OF_USE.AGREE'), type: 'termOfUseFinal' }
      this.questionnaireService.sendGA(this.currentStep,'summarize', termOfUseFinal);
    }
    else {
      this.errorMessage = this.translate.instant('TERMS_OF_USE.AGREE');
    }
  }

  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent): any {
    if (event.key === 'Enter') {
      if ((event.target as HTMLElement).dataset.id === 'check-agree-mail') {
        let checkbox2b = (document.getElementById('checkbox-2') as HTMLInputElement);
        if (checkbox2b.checked) {
          checkbox2b.checked = false;
          this.agree.setValue('');
        } else {
          checkbox2b.checked = true;
          this.agree.setValue('on');
        }
      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/terms-of-use-final/terms-of-use-final.component.ts